var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MessagesList',{class:[_vm.$mq !== 'sm' && 'mt-d2', 'app-border'],attrs:{"id":_vm.orderId,"type":"order","height-diff":"41rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }